import { UseFormReturn } from "react-hook-form";
import type { OrderFormData, CustomerOption, PartnerOption, CemeteryOption, CustomerFormData, PartnerFormData, CemeteryFormData, OrderTrackingInfo } from "../types";
import { CustomerSection } from "../sections/CustomerSection";
import { PartnerSection } from "../sections/PartnerSection";
import { CemeterySection } from "../sections/CemeterySection";
import { DatesSection } from "../sections/DatesSection";
import { OrderTypeSection } from "../sections/OrderTypeSection";

interface BasicInfoTabProps {
  form: UseFormReturn<OrderFormData>;
  customers: CustomerOption[] | undefined;
  partners: PartnerOption[] | undefined;
  cemeteries: CemeteryOption[] | undefined;
  orderId?: string;
  orderTrackingInfo: OrderTrackingInfo | null;
  isCreatingCustomer: boolean;
  setIsCreatingCustomer: (value: boolean) => void;
  customerFormData: CustomerFormData;
  setCustomerFormData: (data: CustomerFormData) => void;
  onCreateCustomer: () => void;
  isCreatingCustomerPending: boolean;
  isCreatingPartner: boolean;
  setIsCreatingPartner: (value: boolean) => void;
  partnerFormData: PartnerFormData;
  setPartnerFormData: (data: PartnerFormData) => void;
  onCreatePartner: () => void;
  isCreatingPartnerPending: boolean;
  isCreatingCemetery: boolean;
  setIsCreatingCemetery: (value: boolean) => void;
  cemeteryFormData: CemeteryFormData;
  setCemeteryFormData: (data: CemeteryFormData) => void;
  onCreateCemetery: () => void;
  isCreatingCemeteryPending: boolean;
}

export function BasicInfoTab(props: BasicInfoTabProps) {
  return (
    <div className="space-y-4">
      <CustomerSection
        form={props.form}
        customers={props.customers}
        orderId={props.orderId}
        orderTrackingInfo={props.orderTrackingInfo}
        isCreating={props.isCreatingCustomer}
        setIsCreating={props.setIsCreatingCustomer}
        formData={props.customerFormData}
        setFormData={props.setCustomerFormData}
        onSubmit={props.onCreateCustomer}
        isSubmitting={props.isCreatingCustomerPending}
      />
      <PartnerSection
        form={props.form}
        partners={props.partners}
        isCreating={props.isCreatingPartner}
        setIsCreating={props.setIsCreatingPartner}
        formData={props.partnerFormData}
        setFormData={props.setPartnerFormData}
        onSubmit={props.onCreatePartner}
        isSubmitting={props.isCreatingPartnerPending}
      />
      <CemeterySection
        form={props.form}
        cemeteries={props.cemeteries}
        isCreating={props.isCreatingCemetery}
        setIsCreating={props.setIsCreatingCemetery}
        formData={props.cemeteryFormData}
        setFormData={props.setCemeteryFormData}
        onSubmit={props.onCreateCemetery}
        isSubmitting={props.isCreatingCemeteryPending}
      />
      <DatesSection form={props.form} />
      <OrderTypeSection form={props.form} />
    </div>
  );
}
